/** @format */

export const AddSizeSmall = ({color}) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_477_178)">
                <path
                    d="M11.9997 8.66668H8.66634V12C8.66634 12.3667 8.36634 12.6667 7.99967 12.6667C7.63301 12.6667 7.33301 12.3667 7.33301 12V8.66668H3.99967C3.63301 8.66668 3.33301 8.36668 3.33301 8.00001C3.33301 7.63334 3.63301 7.33334 3.99967 7.33334H7.33301V4.00001C7.33301 3.63334 7.63301 3.33334 7.99967 3.33334C8.36634 3.33334 8.66634 3.63334 8.66634 4.00001V7.33334H11.9997C12.3663 7.33334 12.6663 7.63334 12.6663 8.00001C12.6663 8.36668 12.3663 8.66668 11.9997 8.66668Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_477_178">
                    <rect width="16" height="16" fill={color} />
                </clipPath>
            </defs>
        </svg>
    );
};
